import './nelsons3/style';
import FormStructure from './nelsons3/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/includes.js